var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prouni-header"},[_c('Logo'),_c('Logo',{staticClass:"prouni-header__college-name",attrs:{"name":"collegeName","width":125}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }